<template>
    <div class="pm-smart-extras-header white"
         style="height: 52px; display: flex; align-items: center; transition: all .4s; width: 100%; justify-content: space-between; box-shadow: inset 0 8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03);"
    >
        <div class="pm-smart-extras-header-region" style="margin-top: -2px; flex-grow: 0;">
            <v-icon style="transition: all .3s; margin: -1px 0 0 14px;" class="black--text">
                plus_circle_outline
            </v-icon>
        </div>
        <div style="flex-grow: 1; padding-left: 8px; padding-right: 8px;min-width: 0;  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="roboto f14 bold--text">
            {{ $t("plan_calculator.extras") }}
        </div>
        <pm-price style="flex-grow: 0; flex-shrink: 0; padding-right: 16px;" class="bold--text roboto f14 black--text" :value="getTotal" />
    </div>
</template>

<style lang="scss">
    .pm-smart-extras-header {
        position: relative;

        .pm-smart-extras-header-region {
            width: 48px;
            text-align: center;
            flex-grow: 0;
            flex-shrink: 0;
        }
    }

@media (min-width: 700px) {
    .pm-smart-extras-header {
        height: 52px !important;
        padding: 0 24px 0 0px;
    }

    .pm-smart-extras-header > div,
    .pm-smart-extras-header > span {
        font-size: 18px;
    }

    .pm-smart-extras-header-region i {
        font-size: 26px !important;
    }
}
</style>


<script>
export default {
    props: {
        total: {
            type: Number,
            default: 0,
        },
        percentage: {
            type: Number,
            default: 0,
        },
    },
    data: () => {
        return ({});
    },
    computed: {
        /**
         *
         * @return {number}
         */
        getTotal() {
            if (this.percentage && this.percentage > 0) {
                const extraValue = Math.round((this.$store.state.simplePlan.upperJawTotal + this.$store.state.simplePlan.lowerJawTotal) * (this.percentage / 100));

                return this.total + extraValue;
            }

            return this.total;
        },
    },
};
</script>
